import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { GetColourArray, getItemFromArray, toNumber } from "../../components/Common";
import { AreaTextField } from "../DesignerCommon";
import AreaSelectField from "../../components/AreaSelectField";
import ColourSelector from "../../components/ColourSelector";
import * as CONFIG from "../../redux_store/configState";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Typography from "@material-ui/core/Typography";
import ListSubheader from "@material-ui/core/ListSubheader";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import MenuItem from "@material-ui/core/MenuItem";

import { blue } from "@material-ui/core/colors";

import {
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import { check_cyclonic } from "../specification_drawer/SpecBeamPostTools";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import BSL_Select from "../../components/BSL_Select";
import BSL_TextInput from "../../components/BSL_TextInput";

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper id="draggable-dialog-title" {...props} />
        </Draggable>
    );
}

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    root: {
        width: 300,
    },
    handleText: {
        textAlign: "center",
        background: "#0000",
        width: "60px",
        border: "1px",
        position: "absolute",
        top: "-25px",
    },
    attachLengthText: {
        textAlign: "center",
        width: "55px",
        border: "0px",
    },
    label: {
        width: "200%",
    },
});

export default function SpecModifyPostDialog(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { onClose, open } = props;
    const item = props.item.post_data ? props.item.post_data : props.item;
    const ConfigDesignOptions = useSelector((state) => state.config.design_options);
    const post_types = useSelector((state) => state.config.post_types);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const area_BEAMS_AND_POSTS = AreaSpecifications[item.areaIndex].BEAMS_AND_POSTS;
    const areaDataPostMods = AreaSpecifications[item.areaIndex].POSTMODIFICATIONS;
    const areaDataPostAdj = AreaSpecifications[item.areaIndex].POSTADJUSTMENTS;
    const designType = AreaSpecifications[item.areaIndex].SHAPE.DesignType;

    const design_options = ConfigDesignOptions[designType];

    const ref = item ? (item.ref5 ? item.ref5 : item.ref) : null;
    const ref2 = item ? (item.ref2 ? item.ref2 : item.ref4) : null;
    const post_length = item && item.lengthQQ ? item.lengthQQ : AreaSpecifications[item.areaIndex].SHAPE.Height;

    let data_mods = getItemFromArray(areaDataPostMods, "Ref", ref, "Ref2", ref2);
    let data_adj = getItemFromArray(areaDataPostAdj, "Ref", ref2);

    //defaults MODIFICATIONS
    let defaultPostType = area_BEAMS_AND_POSTS.PostType;
    let defaultTopConnection = area_BEAMS_AND_POSTS.IntermediatePostsFullHeight;
    // if (item?.TopConnection !== undefined && item?.TopConnection !== -1) defaultTopConnection = toNumber(item?.TopConnection);

    const [topConnectionValue, setTopConnectionValue] = React.useState(
        item?.TopConnection && toNumber(item?.TopConnection) !== -1
            ? toNumber(item?.TopConnection)
            : data_mods && data_mods.TopConnection
            ? data_mods.TopConnection
            : defaultTopConnection
    );

    const [sectionValue, setSectionValue] = React.useState(
        data_mods && data_mods.Section ? data_mods.Section : defaultPostType
    );
    const handleSectionValue = (event, newValue) => {
        setSectionValue(newValue !== undefined ? newValue : event.target.value);
    };

    let defaultPostColour = area_BEAMS_AND_POSTS.PostCol;

    const [colourValue, setColourValue] = React.useState(
        data_mods && data_mods.Colour ? data_mods.Colour : defaultPostColour
    );
    const handleColourValue = (event, newValue) => {
        console.log(newValue !== undefined ? newValue : event.target.value);
        setColourValue(newValue !== undefined ? newValue : event.target.value);
    };

    const [lengthValue, setLengthValue] = React.useState(data_mods && data_mods.Length ? data_mods.Length : "");
    const handleLengthValue = (event, newValue) => {
        setLengthValue(newValue !== undefined ? newValue : event.target.value);
    };

    //defaults ADJUSMTNETR
    const split = item.adj ? item.adj.split("/") : [0, 0];
    const default_adjustment = data_adj ? Number(data_adj.Adjustment) : 0;
    let min_adj = -Number(split[0]) + default_adjustment;
    if (min_adj < -4000) min_adj = -4000;
    let max_adj = Number(split[1]) + default_adjustment;
    if (max_adj > 4000) max_adj = 4000;

    const [adjustmentValue, setAdjustmentValue] = React.useState(default_adjustment);
    const handleAdjustmentValue = (event, newValue) => {
        setAdjustmentValue(newValue !== undefined ? newValue : event.target.value);
    };

    const handleClose = () => {
        onClose();
    };

    const handleReset = () => {
        setSectionValue(defaultPostType);
        setColourValue(defaultPostColour);
        setTopConnectionValue(defaultTopConnection);
        setLengthValue("");
        setAdjustmentValue(0);
    };

    const savePostModifications = () => {
        let new_data_mods = data_mods ? { ...data_mods } : {};
        new_data_mods.Ref = ref;
        new_data_mods.Ref2 = ref2 ? ref2 : "";
        new_data_mods.Position = ref.replaceAll("/", ",");
        new_data_mods.Section = sectionValue !== defaultPostType ? sectionValue : "";
        new_data_mods.Colour = colourValue !== defaultPostColour ? colourValue : "";
        new_data_mods.Length = lengthValue ? lengthValue : "";
        new_data_mods.TopConnection = topConnectionValue !== defaultTopConnection ? topConnectionValue : "";
        new_data_mods.SwapAlignment = data_mods?.SwapAlignment ? data_mods.SwapAlignment : false;

        console.log("new_data_mods", new_data_mods);
        console.log("new_data_mods TF", new_data_mods.TopConnection !== "", new_data_mods.TopConnection);

        if (
            new_data_mods.Section ||
            new_data_mods.Colour ||
            new_data_mods.Length ||
            new_data_mods.SwapAlignment ||
            new_data_mods.TopConnection !== ""
        ) {
            console.log("saving");
            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "POSTMODIFICATIONS",
                    ref,
                    null,
                    new_data_mods,
                    true,
                    ref2 === undefined || ref2.includes("undefined") ? null : ref2
                )
            );
        } else {
            //delete paat from list
            console.log("deleting");
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "POSTMODIFICATIONS",
                    ref,
                    45,
                    undefined,
                    undefined,
                    "Ref2",
                    ref2
                )
            );
        }

        if (ref2) {
            let new_data_adj = data_adj ? { ...data_adj } : {};
            new_data_adj.Ref = ref2 ? ref2 : "";
            new_data_adj.Section = ref2.split("/")[0];
            new_data_adj.Num = ref2.split("/")[1];
            new_data_adj.Adjustment = adjustmentValue;

            if (new_data_adj.Adjustment) {
                dispatch(
                    updateAreaSpecificationModificationArray(
                        item.areaIndex,
                        "POSTADJUSTMENTS",
                        ref2,
                        null,
                        new_data_adj,
                        true
                    )
                );
            } else {
                //delete paat from list
                dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "POSTADJUSTMENTS", ref2));
            }
        }

        onClose();
    };

    // MODS
    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    //DES-1756
    const post_spec = design_options["post"];
    let post_menu_items = [];

    // if (window.FIELDERS) {
    let postwidth = 0;
    for (let tempkey in design_options["post"].options) {
        for (let tempkey2 of design_options["post"].options[tempkey]) {
            if (defaultPostType === tempkey2) {
                postwidth = post_types?.[tempkey2].width;
            }
        }
    }

    // const post_spec = design_options["post"];
    //let post_menu_items = [];
    let is_portal = designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    // for (let key in post_spec.options) {
    //     post_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);

    //     let post_options = [...post_spec.options[key]];
    //     if (key.includes("Box Beams") && is_portal) {
    //         //DES-1774 KC allow 656510 for Gable Hip Roof Designs IF NOT A PORTAL position:
    //         if (item?.ref4 && item.ref4.includes("Portal")) {
    //             //not allowed 65
    //         } else {
    //             post_options.unshift("656510");
    //         }
    //     }

    //     for (let key2 of post_options) {
    //         const post = post_types?.[key2];
    //         console.log("key2", post);
    //         if (post) {
    //             let id = post.id ? post.id : key2;
    //             let name = post.name ? post.name : key2;
    //             if (check_cyclonic(post_spec?.disabled_on_cyclonic, key2, is_cyclonic)) continue;
    //             if (post) {
    //                 let disable = false;
    //                 if (
    //                     window.FIELDERS &&
    //                     is_portal &&
    //                     postwidth > 0 &&
    //                     post.width !== postwidth &&
    //                     item?.ref4 &&
    //                     item.ref4.includes("Portal")
    //                 )
    //                     disable = true;
    //                 post_menu_items.push(
    //                     <MenuItem key={id} value={key2} disabled={disable}>
    //                         {post.thumbnail && (
    //                             <div key={id} className={classes.roofsheet_chip}>
    //                                 <img alt="sheet thumb" src={post.thumbnail} style={{ height: "32px" }} />
    //                             </div>
    //                         )}
    //                         {name}
    //                     </MenuItem>
    //                 );
    //             }
    //         }
    //     }
    // }

    let area_freestanding = AreaSpecifications[item.areaIndex][BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding;

    let options = post_spec?.options;
    if (area_freestanding && post_spec?.freestanding_options) options = post_spec?.freestanding_options;

    if (post_spec && options) {
        for (let key in options) {
            //DES-1010 - No AL for NSW
            if (job?.SiteParameters?.Address?.State.toUpperCase() == "NSW" && key.toUpperCase() == "SHS ALUMINIUM")
                continue;
            if (options?.[key])
                post_menu_items.push(<ListSubheader key={key}>{key.replace("Beam", "Post")}</ListSubheader>);
            if (options?.[key])
                for (let key2 of options[key]) {
                    if (check_cyclonic(post_spec?.disabled_on_cyclonic, key2, is_cyclonic)) continue;
                    const this_post = post_types?.[key2];
                    if (this_post) {
                        let disabled_freestanding = area_freestanding && this_post.allow_freestanding === false;

                        let disabled = false;
                        let disabled_tooltip = "";

                        if (topConnectionValue === 2 && !this_post.allow_side) {
                            disabled = true;
                            disabled_tooltip = "Not available in Beam to Side";
                        }
                        if (topConnectionValue === 2 && !this_post.allow_notched) {
                            disabled = true;
                            disabled_tooltip = "Not available in Notched";
                        }
                        if (topConnectionValue === 3 && !this_post.allow_behind) {
                            disabled = true;
                            disabled_tooltip = "Not available in Post Behind";
                        }

                        post_menu_items.push({
                            Key: this_post.id ? this_post.id : key2,
                            Display:
                                (this_post.name ? this_post.name.replace("Beam", "Post") : key2) +
                                (disabled_freestanding ? " (not suitable)" : ""),
                            Thumbnail: this_post.thumbnail,
                            disabled: disabled_freestanding || disabled,
                            disabledTooltip: disabled_tooltip,
                        });
                    }
                }
        }
    }

    // } else {
    //     //LYSAGHT

    //     //const post_spec = design_options["post"];
    //     //let post_menu_items = [];
    //     for (let key in post_spec.options) {
    //         post_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
    //         for (let key2 of post_spec.options[key]) {
    //             const post = post_types?.[key2];
    //             console.log("key2", post);
    //             if (post) {
    //                 let id = post.id ? post.id : key2;
    //                 let name = post.name ? post.name : key2;
    //                 if (check_cyclonic(post_spec?.disabled_on_cyclonic, key2, is_cyclonic)) continue;
    //                 if (post)
    //                     post_menu_items.push(
    //                         <MenuItem key={id} value={key2}>
    //                             {post.thumbnail && (
    //                                 <div key={id} className={classes.roofsheet_chip}>
    //                                     <img alt="sheet thumb" src={post.thumbnail} style={{ height: "32px" }} />
    //                                 </div>
    //                             )}
    //                             {name}
    //                         </MenuItem>
    //                     );
    //             }
    //         }
    //     }
    // }

    let post_shift_helper_text =
        "Min: " +
        min_adj +
        "mm /Max=" +
        max_adj +
        "mm, *a negative number will move the post towards the front fascia, or to the left.";
    if (min_adj >= max_adj)
        post_shift_helper_text =
            "Post Shift disabled as this post cannot be moved (it may have it position defined elsewhere)";

    let post_notch_allowed = post_types?.[sectionValue]?.allow_notched === true;
    let post_notch_disabled_helpertext = "";

    if (!post_notch_allowed) {
        post_notch_disabled_helpertext = "Not allowed for this post type";
    }

    if (colourValue === "Merbau") {
        post_notch_allowed = false;
        post_notch_disabled_helpertext = "Not allowed in Merbau";
    }

    let post_side_allowed = true;
    let post_side_disabled_helpertext = "";
    if (is_cyclonic && window.LYSAGHT) {
        post_side_allowed = false;
        post_side_disabled_helpertext = "Not allowed in cyclonic";
    }

    let post_behind_allowed = post_types?.[sectionValue]?.allow_behind ?? true;
    let post_behind_allowed_helpertext = "";
    if (!post_behind_allowed) {
        post_behind_allowed_helpertext = "Not allowed for this post type";
    }

    if (post_side_allowed && post_types?.[sectionValue]?.allow_side === false) {
        post_side_allowed = false;
        post_side_disabled_helpertext = "Not allowed for this post type";
    }

    let colours = post_spec.colours;
    if (typeof colours === "string") colours = GetColourArray(colours, config.colour_arrays);
    if (Array.isArray(colours) && !colours.includes(colourValue)) colours.unshift(colourValue);
    console.log("colours", colours);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: "move", paddingBottom: "0px" }}>Modify Post Options</DialogTitle>
            <DialogContent style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {!item && <DialogContentText>Post data is not defined</DialogContentText>}
                {item && (
                    <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
                        <BSL_Select
                            label="Section / Material"
                            style={{ flex: 1 }}
                            value={sectionValue}
                            tight={true}
                            items={post_menu_items}
                            onChange={(event, val) => {
                                setSectionValue(event.target.value);
                            }}
                        />
                        <BSL_ColourSelector
                            tight
                            label="Colour"
                            colourList={colours}
                            value={colourValue}
                            onChange={(val) => handleColourValue(null, val)}
                            style={{
                                marginTop: "-12px",
                            }}
                        />

                        {!(is_portal && window.FIELDERS) && (
                            <SegmentedButtonGroup
                                label="Top Connection Style"
                                tight
                                value={topConnectionValue}
                                items={
                                    window.LYSAGHT
                                        ? [
                                              {
                                                  Key: 1,
                                                  Display: "Beam to Side",
                                                  disabled: !post_side_allowed,
                                                  disabledTooltip: post_side_disabled_helpertext,
                                              },
                                              {
                                                  Key: 2,
                                                  Display: "Notched",
                                                  disabled: !post_notch_allowed,
                                                  disabledTooltip: post_notch_disabled_helpertext,
                                              },
                                              {
                                                  Key: 3,
                                                  Display: "Post Behind Beam",
                                                  disabled: !post_behind_allowed,
                                                  disabledTooltip: post_behind_allowed_helpertext,
                                              },
                                          ]
                                        : [
                                              {
                                                  Key: 0,
                                                  Display: "Post Under Beam",
                                                  disabled: is_cyclonic,
                                                  disabledTooltip: is_cyclonic ? "Disabled in cyclonic" : "",
                                              },
                                              {
                                                  Key: 1,
                                                  Display: "Beam to Side",
                                                  disabled: !post_side_allowed,
                                                  disabledTooltip: post_side_disabled_helpertext,
                                              },
                                          ]
                                }
                                onChange={(event, val) => {
                                    setTopConnectionValue(val);
                                }}
                                style={{
                                    marginTop: "-8px",
                                }}
                            />
                        )}

                        <BSL_TextInput
                            label="Modify Post Length"
                            placeholder={post_length}
                            value={lengthValue}
                            tight
                            allowZero
                            min={100}
                            max={post_length + 2000}
                            endAdornment="mm"
                            onBlur={(val) => {
                                setLengthValue(val);
                            }}
                            style={{
                                width: "250px",
                                marginTop: "-4px",
                                paddingTop: "0px",
                            }}
                            inputPropsStyle={{
                                width: "130px",
                            }}
                        />

                        {/* {ref2 && min_adj !== 0 && max_adj !== 0 && (
                            <BSL_TextInput
                                label="Shift Post"
                                disabled={min_adj >= max_adj}
                                value={adjustmentValue}
                                tight
                                allowZero
                                min={min_adj}
                                max={max_adj}
                                blurOnEnter={true}
                                endAdornment="mm"
                                onBlur={(val) => {
                                    setAdjustmentValue(val);
                                }}
                                style={{
                                    width: "250px",
                                    paddingTop: "0px",
                                }}
                                inputPropsStyle={{
                                    width: "130px",
                                }}
                                helperText={post_shift_helper_text}
                            />
                        )} */}

                        {/* <Typography id="range-slider" gutterBottom>
                            Modify Post Specifications
                        </Typography>
                        <AreaSelectField
                            dark
                            value={sectionValue}
                            items={post_menu_items}
                            clip_overflow
                            onChange={handleSectionValue}
                        />
                        <ColourSelector
                            dark
                            colourList={post_spec.colours}
                            value={colourValue}
                            onChange={(e) => handleColourValue(null, e.target.value)}
                            id="Beam_colour"
                            style={{ width: "100%", textAlign: "left" }}
                        /> */}
                        {/* <AreaTextField
                            root_style={{ width: "200px" }}
                            style={{ width: "200px" }}
                            label="Modify Post Length"
                            dark
                            value={lengthValue}
                            adornmentText="mm"
                            allowZero
                            min={100}
                            max={post_length + 2000}
                            blurOnEnter={true}
                            onBlur={(val) => {
                                handleLengthValue(null, val);
                            }}
                        />

                        {ref2 && min_adj !== 0 && max_adj !== 0 && (
                            <>
                                <Typography id="range-slider" gutterBottom>
                                    Shift Post
                                </Typography>
                                <AreaTextField
                                    disabled={min_adj >= max_adj}
                                    dark
                                    value={adjustmentValue}
                                    adornmentText="mm"
                                    allowZero
                                    min={min_adj}
                                    max={max_adj}
                                    blurOnEnter={true}
                                    onBlur={(val) => {
                                        handleAdjustmentValue(null, val);
                                    }}
                                    helperText={post_shift_helper_text}
                                />
                            </>
                        )} */}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleReset}
                    color="primary"
                    style={{
                        position: "absolute",
                        left: "20px",
                    }}
                >
                    Reset
                </Button>
                <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={savePostModifications} color="primary">
                    Save
                </Button>
            </DialogActions>
            {window.debug && (
                <Typography
                    id="range-slider"
                    variant="caption"
                    gutterBottom
                    style={{
                        backgroundColor: "coral",
                    }}
                >
                    {"DEBUG: ref " + ref + " / ref2 " + ref2}
                </Typography>
            )}
        </Dialog>
    );
}

SpecModifyPostDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
